import classNames from 'classnames';
import styles from './LiveHelpWrapper.module.css';
import { AlumniSansFont } from '../../styles/fonts';
import { useAppSelector } from '../../hooks/reduxHooks';

const LiveHelpWrapper = ({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (t: boolean) => void }) => {
  const locale = useAppSelector((d) => d.locale);
  return (
    <div className={classNames(styles.wrapper, isOpen && styles.open)}>
      <div className={styles.header}>
        <p
          style={{
            fontSize: '40px',
            fontFamily: AlumniSansFont.style.fontFamily,
            fontWeight: 400,
            lineHeight: '48px',
            color: '#181818',
            margin: 0,
          }}
        >
          {locale.live_help_title}
        </p>
        <span onClick={() => setIsOpen(false)}>
          <svg width='13' height='14' viewBox='0 0 13 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M12.1432 11.4507L7.70068 7.05248L12.1432 2.60176C12.5676 2.19015 12.5793 1.51105 12.1694 1.08495C11.7595 0.658847 11.0832 0.647098 10.6589 1.05871L6.27906 5.51993L1.79469 1.05871C1.3848 0.647098 0.720235 0.647098 0.310346 1.05871C-0.0995426 1.47032 -0.0995426 2.13767 0.310346 2.54928L4.75291 7.05248L0.310346 11.4507C-0.0995426 11.8623 -0.0995426 12.5297 0.310346 12.9413C0.720235 13.3529 1.3848 13.3529 1.79469 12.9413L6.27906 8.48007L10.7112 12.9413C11.1211 13.3529 11.7856 13.3529 12.1955 12.9413C12.6054 12.5297 12.6054 11.8623 12.1955 11.4507H12.1432Z'
              fill='#181818'
            />
          </svg>
        </span>
      </div>
      <div className={styles.content}>
        <p className={styles.contentHow}>{locale.live_help_subtitle}</p>
        <p className={styles.contentDesc}>{locale.live_help_text}</p>
        <ul className={styles.contentList}>
          <li>
            <a href='tel:+420 739 04 10 10'>+420 739 04 10 10</a>
          </li>
          <li>
            <a href='tel:+420 739 22 10 10'>+420 739 22 10 10</a>
          </li>
          <li>
            <a href='mailto:info@chrono1010.watch'>info@chrono1010.watch</a>
          </li>
        </ul>
      </div>
      <ul className={styles.socialLinks}>
        <li>
          <a
            href='https://api.whatsapp.com/message/H267KWSNO3DCJ1?autoload=1&app_absent=0'
            target='_blank'
            rel='noreferrer'
            aria-label='WhatsApp'
          >
            <svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M13.6123 2.69531C12.1709 1.21875 10.2021 0.375 8.09277 0.375C3.80371 0.375 0.288086 3.89062 0.288086 8.17969C0.288086 9.58594 0.674805 10.9219 1.34277 12.082L0.25293 16.125L4.36621 15.0703C5.52637 15.668 6.79199 16.0195 8.09277 16.0195C12.417 16.0195 16.0029 12.5039 16.0029 8.21484C16.0029 6.10547 15.0889 4.17188 13.6123 2.69531ZM8.09277 14.6836C6.93262 14.6836 5.80762 14.3672 4.78809 13.7695L4.57715 13.6289L2.11621 14.2969L2.78418 11.9062L2.6084 11.6602C1.97559 10.6055 1.62402 9.41016 1.62402 8.17969C1.62402 4.62891 4.54199 1.71094 8.12793 1.71094C9.85059 1.71094 11.4678 2.37891 12.6982 3.60938C13.9287 4.83984 14.667 6.45703 14.667 8.21484C14.667 11.7656 11.6787 14.6836 8.09277 14.6836ZM11.6787 9.83203C11.4678 9.72656 10.5186 9.26953 10.3428 9.19922C10.167 9.12891 10.0264 9.09375 9.88574 9.30469C9.78027 9.48047 9.39355 9.9375 9.28809 10.0781C9.14746 10.1836 9.04199 10.2188 8.86621 10.1133C7.70605 9.55078 6.96777 9.09375 6.19434 7.79297C5.9834 7.44141 6.40527 7.47656 6.75684 6.73828C6.82715 6.59766 6.79199 6.49219 6.75684 6.38672C6.72168 6.28125 6.2998 5.33203 6.15918 4.94531C5.9834 4.55859 5.84277 4.59375 5.70215 4.59375C5.59668 4.59375 5.45605 4.59375 5.35059 4.59375C5.20996 4.59375 4.99902 4.62891 4.82324 4.83984C4.64746 5.05078 4.15527 5.50781 4.15527 6.45703C4.15527 7.44141 4.82324 8.35547 4.92871 8.49609C5.03418 8.60156 6.2998 10.5703 8.26855 11.4141C9.49902 11.9766 9.99121 12.0117 10.624 11.9062C10.9756 11.8711 11.749 11.4492 11.9248 10.9922C12.1006 10.5352 12.1006 10.1484 12.0303 10.0781C11.9951 9.97266 11.8545 9.9375 11.6787 9.83203Z'
                fill='#535353'
              />
            </svg>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default LiveHelpWrapper;
